"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPicker = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_color_alpha_1 = tslib_1.__importDefault(require("@uiw/react-color-alpha"));
const react_color_saturation_1 = tslib_1.__importDefault(require("@uiw/react-color-saturation"));
const react_color_hue_1 = tslib_1.__importDefault(require("@uiw/react-color-hue"));
const context_1 = require("../../styles/context");
const Space_1 = require("../../3-list-item/Space");
const HslColor_1 = require("../../styles/color/HslColor");
const HsvColor_1 = require("../../styles/color/HsvColor");
const Pointer = ({ style, color, borderColor, ...props }) => {
    const stylePointer = {
        height: 20,
        width: 20,
        position: 'absolute',
        transform: 'translate(-12px, -12px)',
        boxShadow: '0 2px 4px rgb(0 0 0 / 20%)',
        borderRadius: '50%',
        border: `2px solid ${borderColor}`,
        zIndex: 1,
        ...style,
    };
    return (react_1.default.createElement("div", { ...props, style: stylePointer },
        react_1.default.createElement("div", { style: {
                backgroundColor: color,
                borderRadius: '50%',
                height: '100%',
                width: '100%',
            } })));
};
exports.ColorPicker = react_1.default.forwardRef((props, ref) => {
    const { prefixCls = 'jsonjoy-color-picker', className, onChange, color, style, noAlpha, ...other } = props;
    const styles = (0, context_1.useStyles)();
    const pointerBorder = styles.bg + '';
    const checkerboardBg = styles.light ? '#fff' : styles.g(0.78);
    const saturationBottomBorder = styles.light ? '#000' : styles.g(0.92);
    const hsl = HslColor_1.HslColor.from(color ?? '') ?? new HslColor_1.HslColor(0, 0, 0);
    const hsv = hsl.toHsv();
    const hsva = { h: hsv.h * 360, s: hsv.s * 100, v: hsv.v * 100, a: hsv.a };
    return (react_1.default.createElement("div", { ref: ref, style: {
            width: 200,
            position: 'relative',
            ...style,
        }, ...other, className: `${prefixCls} ${className || ''}` },
        react_1.default.createElement(react_color_saturation_1.default, { hsva: hsva, className: prefixCls, radius: "8px", style: { width: 'auto', height: 150, minWidth: 120, borderBottom: `12px solid ${saturationBottomBorder}` }, pointer: ({ left, top }) => react_1.default.createElement(Pointer, { style: { left, top }, color: hsl.toString(), borderColor: pointerBorder }), onChange: ({ h, s, v, a }) => {
                const hsv = new HsvColor_1.HsvColor(h / 360, s / 100, v / 100, a);
                const hsl = HslColor_1.HslColor.from(hsv);
                onChange?.(hsl);
            } }),
        react_1.default.createElement(Space_1.Space, null),
        react_1.default.createElement(react_color_hue_1.default, { hue: hsva.h, height: 24, radius: "8px", className: prefixCls, onChange: ({ h }) => {
                const copy = hsl.copy();
                copy.h = h / 360;
                onChange?.(copy);
            }, pointer: ({ left }) => (react_1.default.createElement(Pointer, { style: { left }, color: `hsl(${hsva.h || 0}deg 100% 50%)`, borderColor: pointerBorder })) }),
        !noAlpha && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Space_1.Space, null),
            react_1.default.createElement(react_color_alpha_1.default, { hsva: hsva, height: 24, className: prefixCls, radius: "8px", style: { ['--alpha-background-color']: checkerboardBg }, pointer: ({ left }) => react_1.default.createElement(Pointer, { style: { left }, color: hsl.toString(), borderColor: pointerBorder }), onChange: (newAlpha) => {
                    const newHsl = hsl.copy();
                    newHsl.a = newAlpha.a;
                    onChange?.(newHsl);
                } })))));
});
